import { borgAnalytics, Button, getChannel, useTheme } from '@ytl/common-web';
import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import MigraSuccessImage from '../../../../assets/migra-success.svg';
import { useLanguage } from '../../../../contexts/languageContext';
import { getConfig } from '../../../data/config';
import { authResource } from '../../../resource/auth.resource';

export const Finish = () => {
  const { translation } = useLanguage();
  const { isWebView } = useTheme();
  const config = getConfig();
  const onboardingFinishLoginAppUrl = config?.onboardingFinishLoginAppUrl || '/loginwithapp';
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useLayoutEffect(() => {
    if (isWebView) {
      document.documentElement.classList.add('ytl--app');
    }
    return () => {
      document.documentElement.classList.remove('ytl--app');
    };
  }, [isWebView]);

  const handleReturnToApp = useCallback(() => {
    window.location.href = onboardingFinishLoginAppUrl;
  }, [onboardingFinishLoginAppUrl]);

  const checkLoginStatus = async () => {
    const result = await authResource.checkLoginStatus();
    setIsAuthenticated(result.isAuthenticated);
  };

  useEffect(() => {
    if (isWebView) {
      checkLoginStatus();
    }
  }, [isWebView]);

  useEffect(() => {
    borgAnalytics.sendVirtualPageView({
      channel: getChannel(isWebView),
      virtualName: 'Registration success',
    });
  }, [isWebView]);

  return (
    <div
      className="register-page"
      id="migra-success-webview"
    >
      <div className="register-page__container">
        <div className="register-page__container__box">
          <div className="migra-webview__character migra-webview__character--large">
            <img
              src={MigraSuccessImage}
              alt="Yettel karakter"
            />
          </div>

          <h3>{translation.onboarding.finish.header}</h3>

          {!isAuthenticated ? (
            <p>{isWebView ? translation.migra.success.descriptionApp : translation.migra.success.description}</p>
          ) : (
            <p>{translation.migra.success.descriptionLoggedIn}</p>
          )}

          <div className="migra-webview__buttons">
            {!isAuthenticated ? (
              <Button
                variant="contained"
                onClick={isWebView ? handleReturnToApp : () => (window.location.href = config.webLoginUrl)}
              >
                {isWebView ? translation.migra.success.continueButtonApp : translation.migra.success.continueButton}
              </Button>
            ) : (
              <>
                <Button
                  variant="contained"
                  onClick={() => (window.location.href = config.closeWebViewUrl)}
                >
                  {translation.migra.success.keepLoggedInButton}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => (window.location.href = `${config.appRedirectBackBaseUrl}?eventName=ForcedLogin`)}
                >
                  {translation.migra.success.switchAccountButton}
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
